import React from 'react';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';

export type ToggleEffect = 'bold' | 'italic' | 'underline';

type Props = {
  title: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  children: React.ReactNode;
  className?: string;
  effect?: ToggleEffect;
};

/** Icon toggle wired to Ant Design Form.Item (valuePropName="checked"). */
export const FormToggleIconButton: React.FC<Props> = ({
  title,
  checked = false,
  onChange,
  children,
  className,
  effect,
}) => {
  const effectClass =
    checked && effect === 'bold'
      ? ' word-ribbon-icon-btn--bold'
      : checked && effect === 'italic'
        ? ' word-ribbon-icon-btn--italic'
        : checked && effect === 'underline'
          ? ' word-ribbon-icon-btn--underline'
          : '';

  return (
    <RibbonIconButton
      title={title}
      active={checked}
      className={`${className ?? ''}${effectClass}`.trim() || undefined}
      onClick={() => onChange?.(!checked)}
    >
      {children}
    </RibbonIconButton>
  );
};
